var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSignupUserIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1688_5662)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 48,
    height: 48,
    rx: 10,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 47,
    height: 47,
    rx: 9.5,
    stroke: "#EAECF0",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9825 31.7247C31.2838 30.7996 30.3798 30.0493 29.3417 29.5331C28.3036 29.0168 27.1599 28.7487 26.0005 28.7497C24.8411 28.7487 23.6974 29.0168 22.6593 29.5331C21.6213 30.0493 20.7172 30.7996 20.0185 31.7247M31.9825 31.7247C33.346 30.5119 34.3076 28.9133 34.7417 27.1408C35.1758 25.3683 35.0608 23.5058 34.412 21.8002C33.7632 20.0946 32.6112 18.6265 31.1089 17.5906C29.6066 16.5547 27.8248 16 26 16C24.1752 16 22.3934 16.5547 20.8911 17.5906C19.3888 18.6265 18.2368 20.0946 17.588 21.8002C16.9392 23.5058 16.8243 25.3683 17.2583 27.1408C17.6924 28.9133 18.655 30.5119 20.0185 31.7247M31.9825 31.7247C30.3365 33.1929 28.2061 34.0028 26.0005 33.9997C23.7945 34.0031 21.6647 33.1931 20.0185 31.7247M29.0005 22.7497C29.0005 23.5454 28.6844 24.3084 28.1218 24.871C27.5592 25.4336 26.7962 25.7497 26.0005 25.7497C25.2049 25.7497 24.4418 25.4336 23.8792 24.871C23.3166 24.3084 23.0005 23.5454 23.0005 22.7497C23.0005 21.9541 23.3166 21.191 23.8792 20.6284C24.4418 20.0658 25.2049 19.7497 26.0005 19.7497C26.7962 19.7497 27.5592 20.0658 28.1218 20.6284C28.6844 21.191 29.0005 21.9541 29.0005 22.7497Z",
    stroke: "#616876",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1688_5662",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1688_5662"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1688_5662",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignupUserIcon);
export default __webpack_public_path__ + "static/media/signup_user_icon.278f7e3f686f44c01ff070b276e1b533.svg";
export { ForwardRef as ReactComponent };